import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_WORKGROUPDETAIL,
  DELETE_WORKGROUPDETAIL,
  UPDATE_WORKGROUPDETAIL,
  ADD_NEW_WORKGROUPDETAIL,
} from "./actionType";

import {
  getWorkGroupDetailSuccess,
  getWorkGroupDetailFail,
  deleteWorkGroupDetailSuccess,
  deleteWorkGroupDetailFail,
  updateWorkGroupDetailSuccess,
  updateWorkGroupDetailFail,
  addWorkGroupDetailSuccess,
  addWorkGroupDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveWorkGroupDetailApi,
  getWorkGroupDetailApi,
  updateWorkGroupDetailApi,
  deleteWorkGroupDetailApi,
  addNewWorkGroupDetailApi
} from "../../helpers/backend_helper";

function* getWorkGroupDetail({ payload: workGroupDetail }) {
  try {
    const response = yield call(getWorkGroupDetailApi, workGroupDetail);
    yield put(getWorkGroupDetailSuccess(GET_WORKGROUPDETAIL, response.data));
  } catch (error) {
    yield put(getWorkGroupDetailFail(GET_WORKGROUPDETAIL, error));
  }
}

function* onUpdateWorkGroupDetail({ payload: workGroupDetail }) {
  try {
    if (workGroupDetail.setApprove) {
      const response = yield call(approveWorkGroupDetailApi, workGroupDetail);
      yield put(updateWorkGroupDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateWorkGroupDetailApi, workGroupDetail);
      yield put(updateWorkGroupDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateWorkGroupDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteWorkGroupDetail({ payload: workGroupDetail }) {
  try {
    const response = yield call(deleteWorkGroupDetailApi, workGroupDetail);
    yield put(deleteWorkGroupDetailSuccess({ workGroupDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteWorkGroupDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewWorkGroupDetail({ payload: workGroupDetail }) {
  try {
    const response = yield call(addNewWorkGroupDetailApi, workGroupDetail);
    yield put(addWorkGroupDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addWorkGroupDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetWorkGroupDetail() {
  yield takeEvery(GET_WORKGROUPDETAIL, getWorkGroupDetail);
}

export function* watchUpdateWorkGroupDetail() {
  yield takeEvery(UPDATE_WORKGROUPDETAIL, onUpdateWorkGroupDetail);
}

export function* watchDeleteWorkGroupDetail() {
  yield takeEvery(DELETE_WORKGROUPDETAIL, onDeleteWorkGroupDetail);
}

export function* watchAddNewWorkGroupDetail() {
  yield takeEvery(ADD_NEW_WORKGROUPDETAIL, onAddNewWorkGroupDetail);
}

function* workGroupDetailSaga() {
  yield all([
    fork(watchGetWorkGroupDetail),
    fork(watchDeleteWorkGroupDetail),
    fork(watchUpdateWorkGroupDetail),
    fork(watchAddNewWorkGroupDetail)
  ]);
}

export default workGroupDetailSaga;
